import React, {useContext} from 'react';
import AuthWrapper from '../../pages/auth/AuthWrapper';
import {UserContext} from './UserContext';

/**
 * Wrapper component that controls field visibility based on access levels.
 * @param accessLevel - The minimum access level required to see this field
 */
export const AdminOrSpecialCoordinatorElement = ({accessLevel, ...props}: any) => {
  const {currentUser} = useContext(UserContext);

  // Curator-only filter: admins and specials do NOT see this
  if (accessLevel === 'district_curator') {
    if (currentUser.role_id === 2 && currentUser.is_access_by_district) {
      return <AuthWrapper {...props} />;
    }

    return null;
  }

  // Existing behavior for other restricted fields (admin/special_coordinator)
  if (currentUser.role_id === 1 || currentUser.is_special) {
    return <AuthWrapper {...props} />;
  }

  return null;
};
